<template>
    <div class="minisite-image-list" :style="getListStyle">
        <template-00 v-if="data.style.templateId === '00'" :data="data"></template-00>
        <template-01 v-if="data.style.templateId === '01'" :data="data"></template-01>
        <template-02 v-if="data.style.templateId === '02'" :data="data"></template-02>
        <template-00 v-if="data.style.templateId === '03'" :data="data"></template-00>
        <template-00 v-if="data.style.templateId === '04'" :data="data"></template-00>
    </div>
</template>
<script>
    import CommonMixIn from "./common.mixin"

    import ImageTemplate from "./image"

    export default {
        name: "ImageComponent",
        mixins: [CommonMixIn],
        components: {
            "template-00": ImageTemplate.Template00,
            "template-01": ImageTemplate.Template01,
            "template-02": ImageTemplate.Template02
        },
        computed: {
            getListStyle() {
                if (this.data.style && this.data.style.background) {
                    return Object.assign(
                        {},
                        this.getBackground(this.data.style.background),
                        this.getPadding(this.data.style.background.padding),
                        this.getMargin(this.data.style.background.margin)
                    )
                }
                return {}
            }
        }
    }
</script>

<style lang="less">
    .minisite-image-list {
        .main-item-content {
            -webkit-backface-visibility: hidden;
            -moz-backface-visibility: hidden;
            -webkit-transform: translate3d(0, 0, 0);
            -moz-transform: translate3d(0, 0, 0);
        }
    }

</style>
